module.exports = __webpack_public_path__ + "img/crystal.3e54bca6.png";